import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import Close from '@mui/icons-material/Close';

import CONSTANTS from '../utils/Constants';
import InvisibleCaptcha from './InvisibleCaptcha';

const StyledAppBar = styled(AppBar)(({ theme, category }) => ({
	backgroundColor: category === 'positive' ? CONSTANTS.COLORS.POSITIVE :
					 category === 'uncertain' ? CONSTANTS.COLORS.UNCERTAIN :
					 category === 'negative' ? CONSTANTS.COLORS.NEGATIVE :
					 category === 'tip' ? CONSTANTS.COLORS.TIP :
					 category === 'transparent' ? theme.palette.background.default :
					 theme.palette.primary.main,
	color: category === 'transparent' ? CONSTANTS.COLORS.BLACK : theme.palette.primary.contrastText,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	minHeight: theme.spacing(9),
	paddingLeft: theme.spacing(3.5),
	paddingRight: theme.spacing(3.5)
}));

const GrowTypography = styled(Typography)({
	flex: 1
});

const StyledIconButton = styled(IconButton)(({ theme }) => ({
	marginRight: -theme.spacing(1)
}));

const StyledCloseIcon = styled(Close)(({ theme, category }) => ({
	borderWidth: 1,
	borderStyle: "solid",
	fontSize: "1.8rem",
	borderColor: category === 'transparent' ? CONSTANTS.COLORS.BLACK : theme.palette.primary.contrastText,
}));

class HeaderBar extends Component {	
	render() {
		let {title, category, closeHandler, recaptchaHandler} = this.props;
		title = title || '';
		let action = (category === 'transparent' && 'categorize_tip') || `share_${category}`;

		return (
			<StyledAppBar position="static" category={category} elevation={0} square>
				<InvisibleCaptcha
					action={action}
					verifyCallback={recaptchaHandler}
				/>
				<StyledToolbar>
					<GrowTypography variant="h6" color="inherit">
						{title}
					</GrowTypography>
					<StyledIconButton
						aria-label="Close"
						color="inherit"
						onClick={closeHandler}
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label="Close"
					>
						<StyledCloseIcon category={category} />
					</StyledIconButton>
				</StyledToolbar>
			</StyledAppBar>
		);
	}
}

HeaderBar.propTypes = {
	category: PropTypes.string.isRequired,
	closeHandler: PropTypes.func.isRequired,
	recaptchaHandler: PropTypes.func.isRequired,
	title: PropTypes.string
};

export default HeaderBar;